import { useCallback } from 'react'
import { type NavigateOptions, useNavigate } from 'react-router-dom'

/** Helper hook to navigate to the entry page of the app */
export const useHomeNavigation = () => {
  const navigate = useNavigate()
  return useCallback(
    (options?: NavigateOptions) => {
      navigate('/', options)
    },
    [navigate],
  )
}
